import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import TransactionalMessageModel from 'cio/models/transactional-message';
import { dropTask } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import AnalyticsService from 'cio/services/analytics';
import DS from 'ember-data';
import RouterService from '@ember/routing/router-service';

export default class TransactionalNewController extends Controller {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service analytics!: AnalyticsService;
  @service store!: DS.Store;
  @service router!: RouterService;

  codeCtaImage = new URL('cio/assets/images/transactional/code-cta.png', import.meta.url).toString();

  @action
  async onCreate(message: TransactionalMessageModel) {
    await message.save();
    this.router.transitionTo('transactional.message.setup', message);
  }

  createSampleTransactionalMessageTask = dropTask(async () => {
    this.analytics.track('transactional', 'hello_world_message_create_started');

    try {
      let response = await this.api.post('transactional_messages_sample/');
      this.store.pushPayload(response);
      this.router.transitionTo('transactional.message.setup.review', response.transactional_message.id);
    } catch (err) {
      this.apiErrors.report(err);
    }
  });
}

declare module '@ember/controller' {
  interface Registry {
    'transactional-new': TransactionalNewController;
  }
}
